import { ConsentId, Platform } from '@/shared/enums';
import { AssetLoader } from '@/shared/utils';
import { getLocation } from '@/shared/plugins/stats/helpers';
import store from '@/shared/store';
import { getCanonicalPath, getProductSections } from './helpers';
import { Strategy } from './strategy';

export default async ({ $deferredLoader, $oneTrust, $services }, inject) => {
  const info = $services.resolve('info');
  const liveManager = $services.resolve('liveManager');

  await info.fetch();
  const {
    accountId,
    domain,
    whitelist = [],
  } = info.chartbeatInfo || {};

  let chartbeatPlayer;

  inject('chartbeat', {
    load(state) {
      if (!window._cbv) {
        return;
      }

      chartbeatPlayer = { state };
      window._cbv.push(chartbeatPlayer);
    },
    destroy() {
      if (!window._cbv || !chartbeatPlayer) {
        return;
      }

      window._cbv.push(['removePlayer', chartbeatPlayer]);
      chartbeatPlayer = null;
    },
    pageView(context = {}) {
      const path = getCanonicalPath();
      const sections = getProductSections(context.product, liveManager);

      if (!window.pSUPERFLY || !window.pSUPERFLY.virtualPage) {
        window._sf_async_config = window._sf_async_config || {};
        window._sf_async_config.path = path;
        window._sf_async_config.sections = sections;
        return;
      }

      window.pSUPERFLY.virtualPage({
        sections,
        path,
        title: window.document.title,
      });
    },
  });

  const location = getLocation();
  const isEmbedded = store.state.platform.name === Platform.EMBEDDED_PLAYER;
  const isDomainBlocked = isEmbedded && whitelist.length > 0 && !whitelist.includes(location.hostname);
  if (!accountId || !domain || isDomainBlocked) {
    return;
  }

  window._cbv_strategies = window._cbv_strategies || [];
  window._cbv_strategies.push(Strategy);
  window._cbv = window._cbv || [];

  window._sf_async_config = window._sf_async_config || {};
  window._sf_async_config.uid = accountId;
  window._sf_async_config.domain = domain;
  window._sf_async_config.path = '/';
  window._sf_async_config.sections = '';
  window._sf_async_config.authors = '';
  window._sf_async_config.autoDetect = false;
  window._sf_async_config.useSubDomains = false;

  Promise.all([
    $deferredLoader.appReady.promise,
    $deferredLoader.oneTrust.promise,
  ])
    .then(() => {
      if (!$oneTrust.areConsentsAccepted([ConsentId.STRICTLY_NECESSARY])) {
        return;
      }

      return new AssetLoader().load([
        { id: 'chartbeat', src: 'https://static.chartbeat.com/js/chartbeat_video.js' },
      ]);
    })
    .catch(() => {});
};
